import React from 'react'
import { useSelector } from 'react-redux'
import { flatten } from 'lodash-es'
import {
    Cartesian3,
    Color
} from 'cesium'
import {
    Entity,
    PolygonGraphics
} from 'resium'

import { selectVertex } from '@/selector'
import { generateVertexes } from '@/util'

const RectangleLayer = () => {
    const vertex = useSelector(selectVertex)
    let polygon
    if (vertex.length === 2) {
        const p = generateVertexes(vertex[0], vertex[1])
        polygon = (
            <PolygonGraphics
                hierarchy={Cartesian3.fromDegreesArray(flatten(p))} 
                material={Color.GREEN.withAlpha(0.3)}
            />
        )
    }
    return (
        <Entity name="PolygonGraphics" description="PolygonGraphics!!">
            {polygon}
        </Entity>
    )
}

export default RectangleLayer